import React from 'react';
import './AirlineLogos.css';

function AirlineLogos() {
  const airlines = [
    { name: 'American Airlines', color: '#0078D2', abbr: 'AA' },
    { name: 'Delta Air Lines', color: '#C8102E', abbr: 'DL' },
    { name: 'United Airlines', color: '#0033A0', abbr: 'UA' },
    { name: 'Southwest Airlines', color: '#304CB2', abbr: 'WN' },
    { name: 'JetBlue Airways', color: '#003876', abbr: 'B6' },
    { name: 'Alaska Airlines', color: '#01426A', abbr: 'AS' },
    { name: 'Spirit Airlines', color: '#FFE900', abbr: 'NK', textColor: '#000' },
    { name: 'Frontier Airlines', color: '#1B8543', abbr: 'F9' },
    { name: 'Hawaiian Airlines', color: '#CC0033', abbr: 'HA' },
    { name: 'Air Canada', color: '#D71921', abbr: 'AC' },
    { name: 'British Airways', color: '#1E3D8F', abbr: 'BA' },
    { name: 'Lufthansa', color: '#05164D', abbr: 'LH' },
    { name: 'Emirates', color: '#D71921', abbr: 'EK' },
    { name: 'Qatar Airways', color: '#5C0A3B', abbr: 'QR' },
    { name: 'Singapore Airlines', color: '#00205B', abbr: 'SQ' },
    { name: 'Air France', color: '#002157', abbr: 'AF' },
  ];

  return (
    <section className="airline-logos-section">
     
    </section>
  );
}

export default AirlineLogos;
